module.exports = __webpack_public_path__ + "static/media/048.f6adedbc.jpg";